<app-loader *ngIf="isDisabled"></app-loader>
<form name="FormFilter" (ngSubmit)="Validate(FormFilter)" #FormFilter="ngForm" class="pb-2">
    <div class="card">
        <div class="card-header">
            Site Date Wise Manpower Report -Front
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <label for="FromDate" class="text-label-dark">From Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="FromDate"
                            [(ngModel)]="this.Filter.FromDateObj" ngbDatepicker #FromDate="ngbDatepicker"
                            [minDate]="MinDate" (ngModelChange)="DateChange($event)" readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                            type="button"></button>
                        <div class="invalid-feedback">
                            Please Select From Date
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <label for="ToDate" class="text-label-dark">To Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="ToDate"
                            [(ngModel)]="this.Filter.ToDateObj" ngbDatepicker #ToDate="ngbDatepicker"
                            [minDate]="MinDate" [maxDate]="MaxDate" readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                            type="button"></button>
                        <div class="invalid-feedback">
                            Please Select To Date
                        </div>
                    </div>
                </div>
                <div class="col-md-4"></div>

                <div class="col-md-6">
                    <label for="RegionID" class="text-label-dark">Region</label>
                    <ng-select name="RegionID" placeholder="Select Region" [(ngModel)]="this.Filter.RegionId"
                        [selectOnTab]="true">
                        <ng-option *ngFor="let Region of Regions"
                            [value]="Region.RegionMasterID">{{Region.RegionName}}</ng-option>
                    </ng-select>
                </div>
                <div class="col-md-6">
                    <label for="ZoneID" class="text-label-dark">Zone</label>
                    <ng-select name="ZoneID" placeholder="Select Zone" [(ngModel)]="this.Filter.ZoneId"
                        [selectOnTab]="true">
                        <ng-option *ngFor="let Zone of Zones" [value]="Zone.ZoneMasterID">{{Zone.ZoneName}}</ng-option>
                    </ng-select>
                </div>
                <div class="col-md-6">
                    <label for="BranchID" class="text-label-dark">Branch</label>
                    <ng-select name="BranchID" placeholder="Select Branch" [(ngModel)]="this.Filter.BranchId"
                        (change)="ComboLoad('Client')" [selectOnTab]="true">
                        <ng-option *ngFor="let Branch of Branchs"
                            [value]="Branch.BranchMasterID">{{Branch.BranchName}}</ng-option>
                    </ng-select>
                </div>
                <div class="col-md-6">
                    <label for="ClientID" class="text-label-dark">Client</label>
                    <ng-select name="ClientID" placeholder="Select Client" [(ngModel)]="this.Filter.ClientId"
                        (change)="ComboLoad('Site')" [selectOnTab]="true">
                        <ng-option *ngFor="let Client of Clients"
                            [value]="Client.ClientGroupMasterID">{{Client.ClientGroupName}}</ng-option>
                    </ng-select>
                </div>
                <div class="col-md-12">
                    <label for="SiteID" class="text-label-dark">Site</label>
                    <ng-select name="SiteID" placeholder="Select Site" [(ngModel)]="this.Filter.SiteId"
                        [selectOnTab]="true">
                        <ng-option *ngFor="let Site of Sites" [value]="Site.SiteMasterID">{{Site.SiteName}}</ng-option>
                    </ng-select>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-primary">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>